import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function FlashMessage(props) {
  const message = props.alertMessage
    ? (typeof props.alertMessage === 'string' ? props.alertMessage : props.alertMessage?.message || JSON.stringify(props.alertMessage))
    : '';

  const severity = props.severity || 'info';

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={props.open}
      onClose={props.handleClose}
      autoHideDuration={!props.alive ? 5000 : undefined}
      // Default Snackbar sits at z-index 1400 but our sticky/fixed header
      // overlaps the top-center spawn point. Push it well above so the
      // toast is fully visible.
      sx={{ zIndex: (t) => t.zIndex.modal + 100, mt: { xs: 8, sm: 10 } }}
    >
      <Alert
        severity={severity}
        onClose={props.handleClose}
        sx={{ width: '100%', alignItems: 'center' }}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={props.handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default FlashMessage;
